import { render } from "./telegram-button.vue?vue&type=template&id=7c8cc1cc"
import script from "./telegram-button.vue?vue&type=script&lang=js"
export * from "./telegram-button.vue?vue&type=script&lang=js"

import "./telegram-button.vue?vue&type=style&index=0&id=7c8cc1cc&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__